export const RANCHO_PACK_IPFS = 'QmSutY5tSAKqfTRaRsPANfQpYUKMhCD1ckx9eEntLaUMJm';
export const GOVERNORS_PACK_IPFS = 'QmcKzaguZ55uF6imMW91S34GMCy7dfcTiz1PAVpHRtCFjY';
export const MAYORS_PACK_IPFS = 'QmSShZnvQQGB6JPM22rquo3rG7Xk8yj3dXqcsX621UndMS';
export const BONUS_PACK_IPFS = 'QmfDHAaVCTaYkBPkn8pa9uHLajruhkDaid3CKuy885UmkU';
